var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLetter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1667 12.167C10.8241 12.4015 10.4147 12.5185 10 12.5003C9.58527 12.5185 9.17586 12.4015 8.83333 12.167L0 7.41699V15.8337C0 16.4967 0.263392 17.1326 0.732233 17.6014C1.20107 18.0703 1.83696 18.3337 2.5 18.3337H17.5C18.163 18.3337 18.7989 18.0703 19.2678 17.6014C19.7366 17.1326 20 16.4967 20 15.8337V7.41699L11.1667 12.167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 1.66699H2.50001C1.83697 1.66699 1.20109 1.93038 0.732245 2.39923C0.263404 2.86807 1.2287e-05 3.50395 1.2287e-05 4.16699V5.00033C-0.000783975 5.1506 0.0371338 5.29854 0.110112 5.4299C0.183091 5.56126 0.288671 5.67161 0.416679 5.75033L9.58335 10.7503C9.7113 10.8177 9.85599 10.8466 10 10.8337C10.144 10.8466 10.2887 10.8177 10.4167 10.7503L19.5833 5.75033C19.7114 5.67161 19.8169 5.56126 19.8899 5.4299C19.9629 5.29854 20.0008 5.1506 20 5.00033V4.16699C20 3.50395 19.7366 2.86807 19.2678 2.39923C18.7989 1.93038 18.1631 1.66699 17.5 1.66699Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetter);
export default __webpack_public_path__ + "static/media/letter.9e38cd2688d72b61df515b073d3d1bb9.svg";
export { ForwardRef as ReactComponent };